define('home/templates/guidelines',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<div class=\"padding-double\">\n<h4 class=\"text-larger\">"
    + container.escapeExpression(helpers.gettext.call(depth0 != null ? depth0 : {},"%(disqus)s Basic Rules",{"name":"gettext","hash":{"disqus":"Disqus"},"data":data}))
    + "</h4>\n<div class=\"spacing-inner -medium spacing-top text-medium\">"
    + ((stack1 = container.invokePartial(partials.homeRules,depth0,{"name":"homeRules","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "</div>\n</div>\n";
},"usePartial":true,"useData":true})

});
